import React, { Fragment } from "react";
import "./ModalTextReadOnly.css";

const ModalTextReadOnly = ({ children, id = "", titulo = "", value = "" }) => {
  return (
    <Fragment>
      <div
        className="componenteAtendimentoModalTextReadOnly_container"
        role="button"
        data-toggle="modal"
        data-target={`#modalModalTextReadOnlyAtendimento${id}`}
      >
        {children}
      </div>

      <div
        className="modal fade"
        id={`modalModalTextReadOnlyAtendimento${id}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby={`modalModalTextReadOnlyAtendimento${id}Label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5
                className="modal-title"
                id={`modalModalTextReadOnlyAtendimento${id}Label`}
              >
                {titulo}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body componenteAtendimentoModalTextReadOnly_modalBody">
              <div className="row">
                <div className="col-12 form-group">
                  <textarea
                    disabled="true"
                    cols="30"
                    rows="10"
                    className="form-control"
                    name="observacao"
                    defaultValue={value}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ModalTextReadOnly;
